export default {"src":"/_next/static/media/btt.ac0eee7e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};